import { inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter, map, startWith } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private readonly router = inject(Router);

  useMinimalLayout: Signal<boolean> = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      startWith({ urlAfterRedirects: this.router.url } as NavigationEnd),
      map(() => this.checkMinimalLayout(this.router.routerState.snapshot.root))
    ),
    { initialValue: false }
  );

  private checkMinimalLayout(snapshot: ActivatedRouteSnapshot): boolean {
    let current: ActivatedRouteSnapshot | null = snapshot;

    while (current) {
      if (current.data?.['layout'] === 'minimal') {
        return true;
      }
      current = current.firstChild;
    }

    return false;
  }
}
